import { FormDialogConfig, Icon } from '@aibees/shared/components';
import { MemberStatus } from '@aibees/shared/definition';
import { yup } from '@aibees/shared/utils';
import { Stack, Typography } from '@mui/material';

export const config: FormDialogConfig = {
  title: (
    <Stack direction="row" alignItems="center" gap={0.5}>
      <Icon size={20} name="person-off-outline" color="primary.500" />
      <Typography variant="body2">Put on Hold</Typography>
    </Stack>
  ),
  closeButton: {
    children: 'Cancel',
    variant: 'text',
    sx: { border: 0 },
  },
};

export const getScheme = (status: MemberStatus) => {
  const isDisabled = status === MemberStatus.disable;
  const action = isDisabled ? 'deactivating' : 'reactivating';

  return yup.object().shape({
    confirmed: yup
      .bool()
      .oneOf([true], `Please confirm ${action} this member before submitting.`),
  });
};
